module.exports = __webpack_public_path__ + "fonts/uv.svg?v=f8480bcaac9db8881a8dce4b59187558";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/uv.svg
// module id = 700
// module chunks = 0